import { CancellablePromise } from './PromiseHelper';

export class Disposable {
    onDisposeCallbacks: (() => unknown)[] = [];

    onDispose(action: () => unknown) {
        this.onDisposeCallbacks.push(action);
    }

    offDispose(action: () => unknown) {
        this.onDisposeCallbacks = this.onDisposeCallbacks.filter((c) => c !== action);
    }

    cancelIfDisposed<T>(prom: CancellablePromise<T> | Promise<T>): Promise<T> {
        const cancellable = prom instanceof CancellablePromise ? prom : CancellablePromise.From(prom);

        const disposeCallback = () => cancellable.cancel();
        this.onDispose(disposeCallback);

        //we don't need to cancel if we completed okay.
        cancellable.result.then(() => this.offDispose(disposeCallback)).catch(() => {});

        return cancellable.result;
    }

    intervalIfNotDisposed(action: () => unknown, intervalMs: number) {
        let timeOutId: ReturnType<typeof setInterval> | null = null;

        const cancelInterval = () => timeOutId !== null && clearInterval(timeOutId);

        this.onDispose(cancelInterval);

        timeOutId = setInterval(() => {
            action();
        }, intervalMs);
    }

    dispose() {
        const onDisposeCallbacks = this.onDisposeCallbacks;
        this.onDisposeCallbacks = [];
        onDisposeCallbacks.forEach((c) => {
            c();
        });
    }
}
